import AppConfiguration from "dataProvider/config";
import BaseService from "./BaseService";

export default class GdmsService extends BaseService {
  constructor() {
    super(AppConfiguration.apiBaseMap, "gdms/v1");
  }

  /**
   * lấy danh sách p2l station-position
   * @returns
   */
  getP2lStationPositions(params) {
    const path = "p2l/station-position/search";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getP2lStationPosition(id) {
    const path = "p2l/station-position";
    const configs = this.getConfigs({
      params: { id }
    });
    return this.doGet(path, configs);
  }

  searchP2lDestination(params) {
    const path = "p2l/destination/search";
    const configs = this.getConfigs({
      baseURL: `${this._baseurl}/${this._endPoint}`,
      params
    });
    return this.doGet(path, configs);
  }

  createP2lStationiPosition(data) {
    const path = "p2l/station-position";
    return this.doPost(path, data);
  }
  editP2lStationiPosition(id, data) {
    const path = "p2l/station-position";
    const configs = this.getConfigs({
      params: { id }
    });
    return this.doPut(path, data, configs);
  }
  deleteP2lStationiPosition(id) {
    const path = "p2l/station-position";
    const configs = this.getConfigs({
      params: { id }
    });
    return this.doDelete(path, configs);
  }

  // https://iot.ghtklab.com/gdms/v1/cmms/task-overview?station_id=17548&from=2024-08-11%2000%3A00%3A00
  getCmmmsTaskOverview(params) {
    const path = "cmms/task-overview";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getCmmmsIncidentTypeWeeklyTrend(params) {
    const path = "cmms/incident-type-weekly-trend";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getCmmmsTrendDevice(params) {
    const path = "cmms/device";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getLatestWheelAlert(params) {
    const path = "wheel-alert/latest_alert";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelAlertConfigs(params) {
    const path = "wheel-alert/configs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelAlertConfig(data) {
    const path = "wheel-alert/configs";
    return this.doPost(path, data);
  }

  updateWheelAlertConfig(data) {
    const path = `wheel-alert/configs`;
    return this.doPost(path, data);
  }

  deleteWheelAlertConfig(id) {
    let path = `wheel-alert/configs/${id}`;
    return this.doDelete(path);
  }

  getWheelAlertValues(params) {
    const path = "wheel-alert/alert-values";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelAlertValues(data) {
    const path = "wheel-alert/alert-values";
    return this.doPost(path, data);
  }

  updateWheelAlertValues(data) {
    const path = `wheel-alert/alert-values`;
    return this.doPost(path, data);
  }

  deleteWheelAlertValues(id) {
    let path = `wheel-alert/alert-values`;
    return this.doDelete(path, { params: { id } });
  }

  getWheelSpecification(params) {
    const path = `wheel-specification`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  deleteWheelSpecification(id) {
    let path = `wheel-specification/${id}`;
    return this.doDelete(path);
  }
  editWheelSpecification(data) {
    let path = `wheel-specification/${data.id}`;
    return this.doPut(path, data);
  }
  addWheelSpecification(data) {
    let path = `wheel-specification`;
    return this.doPost(path, data);
  }

  getWheelPkgJourney(params) {
    const path = `wcs/pkg-journey`;
    const configs = this.getConfigs({
      params,
      responseType: "stream",
      stream: true,
      headers: {
        "Content-Type": "application/stream+json"
      }
    });
    return this.doGetPromise(path, configs);
  }

  exportMachineFault(params) {
    const path = `machine-fault/report/export-machine-fault`;
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return this.doGet(path, configs);
  }

  async updateIncidentDescription(data) {
    const path = "incident/incident-description";
    return await this.doPost(path, data);
  }

  async getDeviceQualityReport(params) {
    const path = "quality/statistic";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getDeviceQualityReportDetail(params) {
    const path = "quality/statistic/details";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async getChildDeviceTypes(params) {
    const path = "device/child-device-types";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getDeviceOfflineStatistic(params) {
    const path = "device/status-statistics";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getDeviceStatus(params) {
    const path = "device/type-status";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  /**
   * Lấy danh sách kho sorting
   */
  async getStations(params) {
    const path = "wms/station";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async getTruckIncidientTicketLog(params) {
    const path = "incident/ticket-log";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  /**
   * Lấy danh sách nhà cung cấp
   */
  async getSuppliers(params) {
    const path = "wms/supplier";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  /**
   * Lấy danh sách layout kho
   */
  async getStationLayouts(params) {
    const path = "wms/station-layout/find";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  /**
   * Tạo layout kho
   */
  async createStationLayout(data, params = {}) {
    const path = "wms/station-layout";
    const configs = this.getConfigs({
      params,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return await this.doPost(path, data, configs);
  }
  /**
   * Sửa layout kho
   */
  async editStationLayout(data, params = {}) {
    const path = "wms/station-layout/update";
    const configs = this.getConfigs({
      params
    });
    return await this.doPost(path, data, configs);
  }
  /**
   * Xóa layout kho
   */
  async deleteStationLayout(id) {
    const path = "wms/station-layout";
    const configs = this.getConfigs({
      params: {
        id
      }
    });
    return await this.doDelete(path, configs);
  }
  /**
   * Lấy thống kê thiết bị
   * @returns
   */
  async getStatisticDevices() {
    let api = `/device/statistic-device`;
    const configs = this.getConfigs({});
    return this.doGet(api, configs);
  }
  /**
   * Lấy danh sách thiết bị
   */
  async getDevicesApp(params) {
    let path = `/device/search/app`;
    const configs = this.getConfigs({
      params: params
    });
    return await this.doGet(path, configs);
  }

  async getDevices(params) {
    let path = `/device/search`;
    switch (params.deviceType) {
      case "MOBILE":
        path = `/device/search`;
        break;

      case "CONVEYOR":
        path = `/device/conveyor/search`;
        break;
    }
    const configs = this.getConfigs({
      params: params
    });
    return await this.doGet(path, configs);
  }

  getEsps(params) {
    let path = `/esp/search`;
    return this.doGet(path, {
      params
    });
  }
  getScanLogs(params) {
    let path = `/scanner/scan-logs/search`;
    return this.doGet(path, {
      params
    });
  }
  getEffectLogs(params) {
    let path = `/device/mobile-log-effects`;
    return this.doGet(path, {
      params
    });
  }
  getActions(params) {
    let path = `/path-actions`;
    return this.doGet(path, {
      params
    });
  }
  addAction(data) {
    let path = `/path-actions`;
    return this.doPost(path, data);
  }
  deleteAction(id) {
    let path = `/path-actions/${id}`;
    return this.doDelete(path);
  }
  // Lấy danh sách loại thiết bị
  getDeviceTypes(params) {
    let path = `/device/types`;
    return this.doGet(path, {
      params
    });
  }

  getCabinets(params) {
    let path = `/cabinet/search`;
    return this.doGet(path, {
      params
    });
  }
  getEspMacs() {
    let path = `/esp/mac`;
    return this.doGet(path);
  }
  getAllConveyorCode() {
    let path = `/device/conveyor/code`;
    return this.doGet(path);
  }
  deleteCabinet(code) {
    let path = `/cabinet`;
    return this.doDelete(path, {
      params: {
        code
      }
    });
  }
  addCabinet(data) {
    let path = `/cabinet`;
    return this.doPost(path, data);
  }
  editCabinet(data) {
    let path = `/cabinet`;
    return this.doPut(path, data);
  }
  getCabinetDetail(code) {
    let path = `/cabinet/detail`;
    return this.doGet(path, {
      params: {
        code
      }
    });
  }
  updateConveyorsCabinet(data) {
    let path = `/cabinet/conveyors`;
    return this.doPut(path, data);
  }
  /**
   * Lấy danh sách Sorting Device
   * @param {*} params Search params
   * @returns
   */
  getSortingDevices(params) {
    let path = `/sorting-device`;
    return this.doGet(path, {
      params
    });
  }
  deleteSortingDevice(code) {
    let path = `/sorting-device`;
    return this.doDelete(path, {
      params: {
        code
      }
    });
  }
  addSortingDevice(data) {
    let path = `/sorting-device`;
    return this.doPost(path, data);
  }
  editSortingDevice(data) {
    let path = `/sorting-device`;
    return this.doPut(path, data);
  }

  /**
   * Lấy danh sách nhà cung cấp của SortingDevice
   * @returns
   */
  getAllSortingDeviceSupplier() {
    let path = `/sorting-device/supplier`;
    return this.doGet(path);
  }

  /**
   * Lấy danh sách loại băng chuyền
   */
  getAllChainType() {
    let path = `/sorting-device/chain-type`;
    return this.doGet(path);
  }

  /**
   * Lấy danh sách sorting cabinetcode
   */
  getSortingDeviceCabinetCode() {
    let path = `/sorting-device/cabinet-code`;
    return this.doGet(path);
  }

  /**
   * Lấy danh sách Sorting Cabinet
   * @param {*} params Search params
   * @returns
   */
  getSortingCabinets(params) {
    let path = `/sorting-device/cabinet`;
    return this.doGet(path, {
      params
    });
  }
  deleteSortingCabinet(code) {
    let path = `/sorting-device/cabinet`;
    return this.doDelete(path, {
      params: {
        code
      }
    });
  }
  addSortingCabinet(data) {
    let path = `/sorting-device/cabinet`;
    return this.doPost(path, data);
  }
  editSortingCabinet(data) {
    let path = `/sorting-device/cabinet`;
    return this.doPut(path, data);
  }
  /**
   * Xoá esp
   */
  deleteEsp(mac) {
    let path = `/esp`;
    return this.doDelete(path, {
      params: {
        mac
      }
    });
  }

  uploadEspFile(params, file) {
    let path = `/esp/upload?mac=${params.mac}&version=${
      params.version
    }&description=${params.description}`;
    return this.doPost(path, file);
  }

  getEspHistory(mac) {
    let path = `/esp/version`;
    return this.doGet(path, {
      params: {
        mac
      }
    });
  }

  // Quản lý cart
  deleteCart(id) {
    let path = `/p2l/cart`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  getCarts(params) {
    let path = `/p2l/cart`;
    return this.doGet(path, {
      params
    });
  }

  addCart(data) {
    let path = `/p2l/cart`;
    return this.doPost(path, data);
  }

  editCart(data) {
    let path = `/p2l/cart`;
    return this.doPut(path, data);
  }

  getModuleMac() {
    let path = `/p2l/module-sorting/macs`;
    return this.doGet(path);
  }

  getListCart() {
    let path = `/p2l/cart/alias`;
    return this.doGet(path);
  }

  // Quản lý module sorting
  deleteModule(id) {
    let path = `/p2l/module-sorting`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  getModule(params) {
    let path = `/p2l/module-sorting`;
    return this.doGet(path, {
      params
    });
  }

  getModuleLogs(params) {
    let path = `/p2l/logs`;
    return this.doGet(path, {
      params
    });
  }

  getProfileP2lLogs(params) {
    let path = `/p2l/module-sorting/log`;
    return this.doGet(path, {
      params
    });
  }

  getModuleCodes(params) {
    let path = `/p2l/module-sorting/code`;
    return this.doGet(path, {
      params
    });
  }

  getModuleConfig(params) {
    let path = `/p2l/module-sorting/config`;
    return this.doGet(path, {
      params
    });
  }

  addModule(data) {
    let path = `/p2l/module-sorting`;
    return this.doPost(path, data);
  }

  editModule(data) {
    let path = `/p2l/module-sorting?id=${data._id}`;
    delete data._id;
    return this.doPut(path, data);
  }

  getDefaultDrawers() {
    let path = `/p2l/module-sorting/default-drawers`;
    return this.doGet(path);
  }

  getModuleLayout() {
    let path = `/p2l/module-sorting/layout`;
    return this.doGet(path);
  }

  saveDetailPlanDrawers(data, params) {
    let path = `/p2l/module-sorting/detail-plan?detail_plan_id=${params.id}`;
    return this.doPut(path, data);
  }

  getDetailPlanDrawers(params) {
    let path = `/p2l/module-sorting/detail-plan`;
    return this.doGet(path, {
      params
    });
  }

  getListCartByCode(params) {
    let path = `/p2l/destination/search`;
    return this.doGet(path, {
      params
    });
  }

  // quản lý kịch bản
  getPlans(params) {
    let path = `/p2l/plan`;
    return this.doGet(path, {
      params
    });
  }

  deletePlan(id) {
    let path = `/p2l/plan`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  addPlan(data) {
    let path = `/p2l/plan`;
    return this.doPost(path, data);
  }

  editPlan(data) {
    let path = `/p2l/plan?id=${data._id}`;
    delete data._id;
    return this.doPut(path, data);
  }

  async updateP2LMSStatus(id, data) {
    let path = `/p2l/module-sorting/device/status/${id}`;
    return this.doPut(path, data);
  }

  activePlan(data) {
    let path = `/p2l/plan?id=${data._id}`;
    delete data._id;
    return this.doPut(path, data);
  }

  // Module sorting XTeam
  getModuleXTeam(params) {
    let path = `/p2l/xteam/module-sorting`;
    return this.doGet(path, {
      params
    });
  }

  deleteModuleXTeam(mac) {
    let path = `/p2l/xteam/module-sorting`;
    return this.doDelete(path, {
      params: {
        mac
      }
    });
  }

  addModuleXTeam(data) {
    let path = `/p2l/xteam/module-sorting`;
    return this.doPost(path, data);
  }

  editModuleXTeam(data) {
    let path = `/p2l/xteam/module-sorting`;
    return this.doPut(path, data);
  }

  // Quản lý thiết bị
  getDeviceP2l(params) {
    let path = `/p2l/module-sorting/device`;
    return this.doGet(path, {
      params
    });
  }

  editDeviceP2l(data) {
    let path = `/p2l/module-sorting/device?id=${data._id}`;
    delete data._id;
    return this.doPut(path, data);
  }

  getDetailDevice(params) {
    let path = `/p2l/module-sorting/device/detail`;
    return this.doGet(path, {
      params
    });
  }

  getMacListDevice() {
    let path = `/p2l/module-sorting/firmware/macs`;
    return this.doGet(path);
  }

  getOtaList(params) {
    let path = `/p2l/module-sorting/firmware`;
    return this.doGet(path, {
      params
    });
  }

  addModuleOta(data) {
    let path = `/p2l/module-sorting/firmware`;
    return this.doPost(path, data);
  }

  deleteModuleOta(id) {
    let path = `/p2l/module-sorting/firmware`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  updateVersionFirmware(params, data) {
    let path;
    if (params && params.station_ids) {
      path = `/p2l/module-sorting/firmware?station_ids=${params.station_ids}`;
    } else {
      path = `/p2l/module-sorting/firmware?macs=${params.macs}`;
    }
    return this.doPut(path, data);
  }

  updateLogOta(params, data) {
    let path = `/p2l/module-sorting/firmware/logs?id=${params.id}`;
    return this.doPut(path, data);
  }

  getDetailOta(params) {
    let path = `/p2l/module-sorting/firmware/detail`;
    return this.doGet(path, {
      params
    });
  }

  updateVersionOta(data) {
    let path = `/p2l/module-sorting/firmware/active`;
    return this.doPost(path, data);
  }

  // Quản lý tủ điện wheel
  getWheelCabinets(params) {
    const path = "wheel/electric-cabinet/list";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelCabinet(data) {
    const path = "wheel/electric-cabinet";
    return this.doPost(path, data);
  }

  updateWheelCabinet(data, id) {
    const path = `wheel/electric-cabinet/${id}`;
    return this.doPut(path, data);
  }

  deleteWheelCabinet(id) {
    let path = `wheel/electric-cabinet/${id}`;
    return this.doDelete(path);
  }

  getServoList() {
    let path = `wheel/servo-driver/filter`;
    return this.doGet(path);
  }

  getListConveyor(params) {
    let path = `wheel/conveyor/filter`;
    return this.doGet(path, {
      params
    });
  }

  // Quản lý băng tải wheel
  getWheelConveyors(params) {
    const path = "wheel/conveyor/latest";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelConveyor(data) {
    const path = "wheel/conveyor";
    return this.doPost(path, data);
  }

  updateWheelConveyor(data, id) {
    const path = `wheel/conveyor/${id}`;
    return this.doPut(path, data);
  }

  deleteWheelConveyor(id) {
    let path = `/wheel/conveyor/${id}`;
    return this.doDelete(path);
  }

  // Quản lý servo
  getWheelServo(params) {
    const path = "wheel/servo-driver/latest";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelServo(data) {
    const path = "wheel/servo-driver";
    return this.doPost(path, data);
  }

  updateWheelServo(data, id) {
    const path = `wheel/servo-driver/${id}`;
    return this.doPut(path, data);
  }

  deleteWheelServo(id) {
    let path = `/wheel/servo-driver/${id}`;
    return this.doDelete(path);
  }

  // Quản lý máng wheel
  getWheelChute(params) {
    const path = "wheel/chute/latest";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteWheelChute(id) {
    let path = `/wheel/chute/${id}`;
    return this.doDelete(path);
  }

  // Quản lý spacing
  getWheelSpacing(params) {
    const path = "wheel/spacing/latest";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteWheelSpacing(id) {
    let path = `/wheel/spacing/${id}`;
    return this.doDelete(path);
  }

  // Quản lý esp mac
  getWheelEsp(params) {
    const path = "wheel/sensor-cabinet/list";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteWheelEsp(id) {
    let path = `/wheel/sensor-cabinet/${id}`;
    return this.doDelete(path);
  }

  createWheelEsp(data) {
    const path = "wheel/sensor-cabinet";
    return this.doPost(path, data);
  }

  /**
   * Lấy thông tin màn hình hoạt động Tụ Thông tin
   * @param {*} params
   * @returns
   */
  getActivityStatistics(params) {
    const path = "maintain/statistics/activity-statistics";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getChecklistFilters(params) {
    const path = "maintain/checklists/filters";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getDeviceChild(params) {
    const path = "device/childs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getDeviceDataTypes(params) {
    const path = "device/data-types";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy thông tin màn hình thiết bị Tụ Thông tin
   * @param {*} params
   * @returns
   */
  getDeviceStatistics(params) {
    const path = "maintain/statistics/device-statistics";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  /**
   * Lấy thông tin màn hình thiết bị Tụ Thông tin
   * @param {*} params
   * @returns
   */
  getDeviceStatusOverview(params) {
    const path = "device/status-overview";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getDeviceMaintainStatistic(params) {
    const path = "maintain/statistics";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  updateWheelEsp(data) {
    const path = `wheel/sensor-cabinet`;
    return this.doPut(path, data);
  }

  // Quản lý checklist công việc

  updateAssetDeviceMaintainJobs(data) {
    const path = "asset-device/maintain-jobs";
    return this.doPut(path, data);
  }

  updateManyAssetDeviceMaintainJobs(data) {
    const path = "asset-device/maintain-jobs-bulk";
    return this.doPut(path, data);
  }

  getAssetDeviceJobFrequencies(params) {
    const path = "asset-device/device-job-frequency";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getMaintainJobs(params) {
    const path = "maintain/jobs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  createMaintainJob(data) {
    const path = "maintain/jobs";
    return this.doPost(path, data);
  }
  editMaintainJob(data) {
    const path = "maintain/jobs";
    return this.doPut(path, data);
  }
  deleteMaintainJob(task_id) {
    const path = `maintain/jobs?id=${task_id}`;
    return this.doDelete(path);
  }
  getJobsCheckLists(id) {
    const path = `maintain/jobs/checklists?maintain_job_id=${id}`;
    return this.doGet(path);
  }

  getChecklistByTask(params) {
    const path = "maintain/checklists/device-type-config";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getChecklistByDevice(params) {
    const path = "maintain/checklists";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getChecklistFilter(params) {
    const path = "maintain/checklists/filters";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteChecklistDevice(id) {
    let path = `maintain/checklists?id=${id}`;
    return this.doDelete(path);
  }

  createChecklistDevice(data) {
    const path = "maintain/checklists";
    return this.doPost(path, data);
  }

  updateChecklistDevice(data) {
    const path = `maintain/checklists/${data.id}`;
    delete data.id;
    return this.doPut(path, data);
  }

  updateChecklistTotal(data) {
    const path = `maintain/checklists/device-type-config`;
    return this.doPost(path, data);
  }

  getTimeline(params) {
    const path = "maintain/tasks";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteTimelineTask(id) {
    let path = `maintain/tasks?task_id=${id}`;
    return this.doDelete(path);
  }

  getShiftInDay(params) {
    const path = "maintain/shift-in-day";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteShiftInDay(id) {
    let path = `maintain/checklists?shift_id=${id}`;
    return this.doDelete(path);
  }

  getTimelineShiftInDay(params) {
    const path = `maintain/shift-in-day/${params.shift_id}`;
    delete params.shift_id;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateAssignUser(data) {
    const path = `maintain/shift-in-day/assign-user`;
    return this.doPut(path, data);
  }

  getConfigShift(params) {
    const path = `maintain/shift-in-day/shift-config`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getConfigStationShift(params) {
    const path = "maintain/shift-config/station";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  editConfigStationShift(data) {
    const path = "maintain/shift-config/station";
    return this.doPut(path, data);
  }

  updateConfigShift(data) {
    const path = `maintain/shift-in-day/shift-config`;
    return this.doPut(path, data);
  }

  updateUserInShift(data) {
    const path = `maintain/shift-in-day/change-user`;
    return this.doPut(path, data);
  }

  // Quản lý tài sản
  getAssetList(params) {
    const path = `asset-device`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateAssetDevice(data) {
    const path = `asset-device`;
    return this.doPut(path, data);
  }

  updateAssetDeviceMaintainConfig(data) {
    const path = `asset-device/maintain-config`;
    return this.doPut(path, data);
  }

  createAssetDevice(data) {
    const path = `asset-device`;
    return this.doPost(path, data);
  }

  deleteAssetDevice(id) {
    let path = `asset-device`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  getAssetDevice(params) {
    const path = `asset-device/all`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getAssetType(params) {
    const path = `asset-device/all-types`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateAssetType(data) {
    const path = `asset-device/type`;
    return this.doPut(path, data);
  }

  createAssetType(data) {
    const path = `asset-device/type`;
    return this.doPost(path, data);
  }

  deleteAssetType(id) {
    let path = `asset-device/type`;
    return this.doDelete(path, {
      params: {
        id
      }
    });
  }

  getChildDevice(params) {
    const path = `asset-device/children`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Profile Crossbelt
  getCrossbeltLogs(params) {
    const path = `device/mobile/profile/activity-logs`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Profile thiết bị theo device_id
  getProfileDeviceById(params) {
    const path = `device/profile`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getProfileActivity(params) {
    const path = `device/mobile/profile/activity-logs`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Quản lý thiết bị wheelsorter
  getWheelDevices(params) {
    let path = `wheel-device`;
    return this.doGet(path, {
      params
    });
  }

  getWheelFilter() {
    let path = `wheel-device/filters`;
    return this.doGet(path);
  }

  deleteWheelDevice(device_id) {
    let path = `wheel-device`;
    return this.doDelete(path, {
      params: {
        device_id
      }
    });
  }

  createWheelDevice(data) {
    const path = `wheel-device`;
    return this.doPost(path, data);
  }

  updateWheelDevice(id, data) {
    const path = `wheel-device/${id}`;
    return this.doPut(path, data);
  }

  // Màn hình KTV
  getTechnicianTaskList(params) {
    const path = `maintain/device-team/tasks`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getTechnicianTaskListExport(params) {
    const path = `maintain/device-team/tasks/export`;
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return this.doGet(path, configs);
  }

  // Profile Task
  getProfileTasks(params) {
    const path = "maintain/mobile/tasks";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteTechnicianTask(task_id) {
    let path = `/maintain/device-team/tasks/${task_id}`;
    return this.doDelete(path);
  }

  createTechnicianTask(data) {
    const path = `maintain/device-team/tasks`;
    return this.doPost(path, data);
  }

  updateTechnicianTask(data) {
    const path = `maintain/device-team/tasks/${data.id}`;
    delete data.id;
    return this.doPut(path, data);
  }
  updateTechnicianTaskId(data) {
    const path = `maintain/device-team/tasks/${data.task_id}`;
    delete data.id;
    return this.doPut(path, data);
  }

  getTaskType() {
    const path = `device-team/task-type/all`;
    return this.doGet(path);
  }

  getDetailProfileTask(params) {
    const path = `maintain/mobile/subtasks`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Profile incident
  getProfileIncidents(params) {
    const path = "device/incident";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getProfileLogs(params) {
    const path = "device/profile/package-logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getProfileIncidentsTotal(params) {
    const path = "device/incident-statistic";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getChecklistFreq(params) {
    const path = "maintain/checklists/freq-config";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateChecklistFreq(data) {
    const path = `maintain/checklists/freq-config`;
    return this.doPost(path, data);
  }

  getKtvFilters() {
    const path = "maintain/device-team/filters";
    return this.doGet(path);
  }

  getStationManageList(params) {
    const path = `station-info`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  updateStationsInfo(data) {
    const path = `station-info/${data.id}`;
    delete data.id;
    return this.doPut(path, data);
  }

  getErrorChecklistById(params) {
    const path = `error-report/device-checklist`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getIncidentErrorFilter(params) {
    const path = `incident/error-detail/filter`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  addIncidentExecutor(data) {
    const path = `incident/machine/executor`;
    return this.doPost(path, data);
  }

  getStationList() {
    const path = `station-info/all`;
    return this.doGet(path);
  }

  getFlashScannerLogs(params) {
    const path = `flash-scanner/logs`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelSorterDashboard(params) {
    const path = "wheel/statistic";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelDashboardDetail(params) {
    const path = "wheel/statistic/detail-logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelSorterDashboardShop(params) {
    const path = "wheel/statistic/shop-report";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelDashboardShopDetail(params) {
    const path = "wheel/statistic/shop-report/detail-logs";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getMachineFaultList(params) {
    const path = `machine-fault/report`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getShopCodeList() {
    const path = `shop-package-report/shop-code`;
    return this.doGet(path);
  }

  getTotalItemInShop(params) {
    const path = "wheel/statistic/shop-report/total-by-station";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getStatisticDeviceById(params) {
    const path = `quality/statistic/overall-statistic`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  getChannels() {
    const path = `machine-fault/report/channel-mapping`;
    return this.doGet(path);
  }

  // Thời gian thực thiện của KTV
  getTechnicianResourceList(params) {
    const path = `maintain/statistics/resource-statistic`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  exportTechnicianResource(params) {
    const path = `maintain/statistics/resource-statistic/export`;
    const configs = this.getConfigs({
      params,
      responseType: "blob"
    });
    return this.doGet(path, configs);
  }

  exportDeviceAssetLog(params) {
    const path = `asset-device/export`;
    const configs = this.getConfigs({ params, responseType: "blob" });
    return this.doGet(path, configs);
  }

  getSupplierTask(params) {
    const path = `maintain/supplier-task`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getFaultList(params) {
    const path = `fault-metadata`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteSupplierTask(task_id) {
    let path = `maintain/supplier-task/${task_id}`;
    return this.doDelete(path);
  }

  createSupplierTask(data) {
    const path = `maintain/supplier-task`;
    return this.doPost(path, data);
  }

  updateSupplierTask(task_id, data) {
    let path = `maintain/supplier-task/${task_id}`;
    return this.doPut(path, data);
  }

  getSupplierFilters() {
    const path = `maintain/supplier-task/filters`;
    return this.doGet(path);
  }

  getUserByTeam(params) {
    const path = `team-members/get-by-team`;
    return this.doGet(path, {
      params: params
    });
  }

  updateAcceptanceSupplier(task_id, data) {
    let path = `maintain/supplier-task/acceptance/${task_id}`;
    return this.doPut(path, data);
  }

  getTransferAssetLog(params) {
    const path = `asset-transfer/history`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  retrySyncTransferAsset(params) {
    const path = `asset-transfer/retry`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getCloseShiftLog(params) {
    const path = `maintain/shift-closing-logs`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getFaultDataList(params) {
    const path = `fault-metadata/pages`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteFaultData(id) {
    let path = `fault-metadata/${id}`;
    return this.doDelete(path);
  }

  getFaultDeviceTypes() {
    const path = `fault-metadata/fault-device-types`;
    return this.doGet(path);
  }

  createFaultData(data) {
    const path = `fault-metadata`;
    return this.doPost(path, data);
  }

  updateFaultData(id, data) {
    let path = `fault-metadata/${id}`;
    return this.doPut(path, data);
  }

  retrySyncEsp(params) {
    const path = `esp/version/wms-sync`;
    return this.doGet(path, {
      params: params
    });
  }

  getWheelCaptureErrorLog(params) {
    const path = `wheel-alert-log`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Module sorting log
  getModuleSortingLog(params) {
    const path = `p2l/wms-logs`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Module sorting list
  getModuleSortingList(params) {
    const path = `p2l/module-sorting/wms`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getModuleSortingCodeList(params) {
    const path = `p2l/module-sorting/code`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getModuleSortingLayout(params) {
    const path = `p2l/module-sorting/layout`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWhiteList(params) {
    const path = `p2l/module-sorting/deletable-users`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteModuleSorting(id) {
    const path = `p2l/module-sorting?id=${id}`;
    return this.doDelete(path);
  }

  updateModuleSortingStatus({ id, status }) {
    const path = `p2l/module-sorting/update-active?id=${id}&active=${status}`;
    return this.doPut(path);
  }

  getPlanCrossbelt(params) {
    const path = `/p2l/sorting-plan`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getPlanBombay(params) {
    const path = `/p2l/bombay-sorting-plan`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getZoneData(params) {
    const path = `/station-zone/zone`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getTransportTypes() {
    const path = `/p2l/module-sorting/transport-types`;
    return this.doGet(path);
  }

  getPackageTypes() {
    const path = `/p2l/module-sorting/package-types`;
    return this.doGet(path);
  }

  // Cross belt
  getChutesCrossbeltByZone(params) {
    const path = `p2l/crossbelt-chute`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getCrossbeltDestinations(params) {
    const path = `p2l/destination/crossbelt-destination`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createModuleSortingCrossbelt(params) {
    const path = `p2l/module-sorting/sorting`;
    return this.doPost(path, params);
  }

  updateModuleSortingCrossbelt(id, data) {
    const path = `p2l/module-sorting/sorting?id=${id}`;
    return this.doPut(path, data);
  }

  // Bombay
  createModuleSortingBombay(params) {
    const path = `p2l/module-sorting/bombay`;
    return this.doPost(path, params);
  }

  updateModuleSortingBombay(id, data) {
    const path = `p2l/module-sorting/bombay?id=${id}`;
    return this.doPut(path, data);
  }

  getChutesBombayByZone(params) {
    const path = `p2l/bombay-chute`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getBombayDestinations(params) {
    const path = `p2l/destination/bombay-destination`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Lego
  createModuleSortingLego(params) {
    const path = `p2l/module-sorting/lego`;
    return this.doPost(path, params);
  }

  updateModuleSortingLego(id, data) {
    const path = `p2l/module-sorting/lego?id=${id}`;
    return this.doPut(path, data);
  }

  getDeviceDetail(params) {
    const path = `p2l/module-sorting/${params.type}?id=${params.id}`;
    return this.doGet(path);
  }

  updateModuleType({ id, data }) {
    const path = `p2l/module-sorting/plan?id=${id}`;
    return this.doPut(path, data);
  }

  // Thông số thiết bị
  getDeviceParameter(params) {
    const path = `device-parameters/list`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getDetailDeviceParameter(id) {
    const path = `device-parameters/${id}`;
    return this.doGet(path);
  }

  createDeviceParameter(data) {
    const path = `device-parameters`;
    return this.doPost(path, data);
  }

  updateDeviceParameter(id, data) {
    const path = `device-parameters/${id}`;
    return this.doPut(path, data);
  }

  deleteDeviceParameter(id) {
    const path = `device-parameters/${id}`;
    return this.doDelete(path);
  }

  getDeviceSpec(params) {
    const path = `/device-specific-parameter`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteDeviceSpec(id) {
    const path = `device-specific-parameter/${id}`;
    return this.doDelete(path);
  }

  createDeviceSpec(data) {
    const path = `device-specific-parameter`;
    return this.doPost(path, data);
  }

  updateDeviceSpec(id, data) {
    const path = `device-specific-parameter/${id}`;
    return this.doPut(path, data);
  }

  uploadDeviceSpecFile(params, file) {
    let path = `asset-device/file?device_id=${params.device_id}`;
    return this.doPut(path, file);
  }
}
